const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrantUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M128.2,1.9s0,0-.1,0c-39.8,0-72,32.3-72,72,0,22.8,10.8,44.3,29.2,57.9C35.3,150,2.1,197.4,2.1,250.5v3.6h21.7v-3.6c0-57.6,46.7-104.4,104.4-104.5h0c39.8,0,72-32.3,72-72h0c0-39.8-32.2-72-72-72ZM128.1,124.4c-27.8,0-50.4-22.6-50.4-50.4h.1c0-27.8,22.5-50.4,50.3-50.4,27.8,0,50.4,22.6,50.4,50.4s-22.6,50.4-50.4,50.4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.5,251.4c-3.1-3.2-3-8.3.1-11.4l10.2-10h-58.6c-4.5,0-8.1-3.6-8.1-8.1,0-4.5,3.6-8.1,8.1-8.1h78.4c3.3,0,6.3,2,7.5,5,.4,1,.6,2,.6,3.1,0,2.2-.9,4.3-2.4,5.8l-24.5,23.9c-1.5,1.5-3.5,2.3-5.7,2.3-2.2,0-4.2-.9-5.8-2.5h0Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.4,199c-3.3,0-6.3-2-7.5-5-1.2-3-.5-6.5,1.8-8.8l24.5-23.9c3.2-3.1,8.3-3.1,11.4.1,0,0,0,0,0,0,3.1,3.2,3.1,8.3-.1,11.4,0,0,0,0,0,0l-10.2,10h58.6c4.5,0,8.1,3.6,8.1,8.1,0,0,0,0,0,0,0,4.5-3.6,8.1-8.1,8.1,0,0,0,0,0,0h-78.4Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantUser);
export default __webpack_public_path__ + "static/media/grant-user.fbbe4d5c6e01002fd8f376685c25f9da.svg";
export { ForwardRef as ReactComponent };